import { useNavigate } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import { getUserDisplayName } from "../../helper/common";
import styles from "./TenantGreeting.module.css";

const TenantGreeting = ({ user, isGuarantor = false }) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const name = getUserDisplayName(user, "").split(" ")[0] || user?.fname || "";

  if (isGuarantor) {
    const fullName = getUserDisplayName(user, "") || user?.fname || "";
    return (
      <div className={styles.wrap}>
        <button
          type="button"
          className={styles.back}
          onClick={() => navigate("/home")}
        >
          <span aria-hidden="true">←</span>{" "}
          {_t("backToMyProfile", "Back to my profile")}
        </button>
        <h1 className={styles.guarantorName}>{fullName}</h1>
        <p className={styles.guarantorSub}>
          {_t("guarantor", "Guarantor")}
          <span aria-hidden="true" className={styles.dot}>
            {"  ·  "}
          </span>
          {_t("viewOnly", "View only")}
        </p>
      </div>
    );
  }

  return (
    <div className={styles.wrap}>
      <h1 className={styles.title}>
        {_t(
          "hiNameHeresYourSkorProfile",
          `Hi ${name}, here's your Skor profile`,
          undefined,
          { name }
        )}
      </h1>
    </div>
  );
};

export default TenantGreeting;
